'use strict'

/*
 * Module qui contient les données des profils et les persistes
 * dans les cookies en JSON
 */

let profiles = {}
let currentProfile = {
    name: '',
    gender: '',
    selected: false,
    sizes: {}
}

const COOKIE_NAME = 'MP'
const LINK_EVENT_DELETE_COOKIE = '.j_deleteCookie'
const URL_UPDATE_COOKIE = '/_3MPlus/UpdateCookie'
const DECODED_GENRES = {
    W: 'FEMME',
    M: 'HOMME',
    G: 'FILLE',
    B: 'GARCON'
}
const ENCODED_EGENRES = { FEMME: 'W', HOMME: 'M', FILLE: 'G', GARCON: 'B' }

/*
 * Récupère le cookie du profil s'il existe, et créer l'objet correspondant.
 */
function init() {
    profiles = getCookie()

    if (!profiles) {
        profiles = [
            {
                gender: DECODED_GENRES.W,
                name: DECODED_GENRES.W,
                selected: false,
                sizes: {}
            },
            {
                gender: DECODED_GENRES.M,
                name: DECODED_GENRES.M,
                selected: false,
                sizes: {}
            },
            {
                gender: DECODED_GENRES.G,
                name: DECODED_GENRES.G,
                selected: false,
                sizes: {}
            },
            {
                gender: DECODED_GENRES.B,
                name: DECODED_GENRES.B,
                selected: false,
                sizes: {}
            }
        ]
        return
    }

    profiles = profiles.map((x) => {
        return {
            gender: DECODED_GENRES[x.G],
            selected: x.SE ?? false,
            name: DECODED_GENRES[x.G],
            sizes: x.S.reduce((acc, elem) => {
                const [_, type] = elem.split('|')

                if (acc[type]) {
                    acc[type] = [...acc[type], elem]
                    return acc
                }

                acc[type] = [elem]

                return acc
            }, {}),
            lastupdated: {}
        }
    })
}

/*
 * Récupère le cookie s'il existe et le transforme en objet
 */
function getCookie() {
    const name = COOKIE_NAME + '='
    const cookiesArray = document.cookie.split(';')
    let cookie = ''

    for (let i = 0; i < cookiesArray.length; i++) {
        // On récupère le cookie
        cookie = cookiesArray[i].trim()

        if (cookie && cookie.indexOf(name) === 0) {
            return JSON.parse(cookie.substring(name.length, cookie.length))
        }
    }
    return undefined
}

/*
 * Enregistre le cookie
 */
function saveCookie() {
    const now = new Date()

    const cookieData = JSON.stringify(
        profiles.map((x) => ({
            G: ENCODED_EGENRES[x.gender],
            S: Object.values(x.sizes).reduce((acc, elem) => [...acc, ...elem], []),
            V: x.version,
            LU: x.lastupdated
        }))
    )

    now.setTime(now.getTime() + 3650 * 24 * 60 * 60 * 1000) // le cookie expire dans 10 ans

    document.cookie =
        COOKIE_NAME +
        '=' +
        cookieData +
        ';expires=' +
        now.toGMTString() +
        ';domain=' +
        window.location.hostname +
        ';path=/'

    // Envoi du cookie au serveur pour sauvegarde
    $.ajax({
        url: URL_UPDATE_COOKIE,
        success: function (data) {}
    })
}

function deleteObjectProperty(o, prop) {
    if (o.hasOwnProperty(prop)) {
        delete o[prop]
    }
}

/*
 * Supprime le cookie
 */
function deleteCookie() {
    document.cookie =
        COOKIE_NAME +
        '=; expires=Thu, 01 Jan 1970 00:00:01 GMT' +
        ';domain=' +
        window.location.hostname +
        ';path=/'
}

/*
 * Récupère les données présent dans les éléments $category et $selectedSize
 * qui représente une partie du DOM
 */
function saveDataAsCookie(category, name, data, dataFamily) {
    if (name === '' || !profiles) {
        return
    }

    if (!Object.keys(data).length) {
        data = { [dataFamily]: [] }
    }

    profiles.forEach((x) => {
        x.selected = false

        if (x.name === name) {
            x.sizes = data
            x.selected = true
            x.lastupdated[dataFamily] = new Date().toISOString()
            currentProfile = x
        }
    })

    saveCookie()
}

/*
 * Vérifie si il existe un profil pour le genre passé en paramètre
 * retourne son nom ou undefined
 */
function existProfilByGender(gender) {
    let name

    for (const i in profiles) {
        // On compte combien de profils on a dans notre cookie
        if (profiles.hasOwnProperty(i)) {
            if (profiles[i].G === gender) {
                name = profiles[i].N
            }
        }
    }
    return name
}

/*
 * Va sortir le profil qui a le numéro le plus élevé
 */
function getMaxNbOfProfile() {
    let cpt = 0
    let tmpcpt = 0

    for (const i in profiles) {
        if (profiles.hasOwnProperty(i)) {
            if (!isNaN(parseInt(profiles[i].N.slice(-1)))) {
                tmpcpt = parseInt(profiles[i].N.slice(-1))
                if (tmpcpt > cpt) {
                    cpt = tmpcpt
                }
            }
        }
    }
    return cpt
}

/*
 * Set le profil concerné en selected et set l'ancien
 * profil qui était sélectionné en non sélectionné
 */
function setSelected(name) {
    init()
    profiles[currentProfile.name].selected = false
    profiles[name].selected = true
    currentProfile = profiles[name]
    saveCookie()
}

function getProfileByGender(gender) {
    for (const i in profiles) {
        if (profiles.hasOwnProperty(i)) {
            if (profiles[i].gender === gender) {
                return profiles[i]
            }
        }
    }
    return undefined
}

function getProfiles() {
    return profiles
}

function getCurrentProfile() {
    return currentProfile
}

function setEventDeleteProfileAndReloadPage() {
    $(LINK_EVENT_DELETE_COOKIE).on('click', function (event) {
        deleteCookie()
        location.reload()
    })
}

function addSize(genre, nature, taille) {
    const profile = profiles.find((x) => x.gender === genre)

    if (!profile) {
        return
    }

    if (!profile.sizes[nature]) {
        profile.sizes[nature] = [taille]
        saveCookie()
        return
    }

    if (profile.sizes[nature].includes(taille)) {
        profile.sizes[nature] = profile.sizes[nature].filter((x) => x !== taille)
    } else {
        profile.sizes[nature] = [...profile.sizes[nature], taille]
    }

    console.log(profile.sizes[nature])

    saveCookie()
}

// Appel du constructeur
init()

export default {
    init: init,
    getProfiles: getProfiles,
    getCurrentProfile: getCurrentProfile,
    saveCookie: saveCookie,
    deleteCookie: deleteCookie,
    saveDataAsCookie: saveDataAsCookie,
    existProfilByGender: existProfilByGender,
    setSelected: setSelected,
    getMaxNbOfProfile: getMaxNbOfProfile,
    getProfileByGender: getProfileByGender,
    setEventDeleteProfileAndReloadPage: setEventDeleteProfileAndReloadPage,
    addSize: addSize
}
